import { apiSlice } from "../app/api/apiSlice";

export const libraryApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getLibraryData: builder.query({
      query: () => ({
        url: "/folder",
        method: "GET",
        params: {
          folderId: "root",
        },
      }),
      providesTags: ["FolderFileData"],
    }),
    FolderContent: builder.mutation({
      query: ({ folderId }) => ({
        url: `/folder/getFolderDetails/`,
        method: "POST",
        body: { folderId },
      }),
      providesTags: (result, error, arg) => {
        if (result?.ids) {
          return [
            { type: "FolderFileData", id: arg.folderId },
            ...result.ids.map((id) => ({ type: "FolderFileData", id })),
          ];
        } else return [{ type: "FolderFileData", id: arg.folderId }];
      },
      invalidatesTags: [{ type: "FolderFileData", id: (arg) => arg.folderId }],
    }),
    CreateFolder: builder.mutation({
      query: ({ folderName, parentFolderId }) => ({
        url: `/folder/create`,
        method: "POST",
        body: { folderName, parentFolderId },
      }),
      invalidatesTags: [{ type: "FolderFileData", id: "root" }],
    }),
    editFolderName: builder.mutation({
      query: ({ folderId, name }) => ({
        url: `/folder/edit`,
        method: "POST",
        params: { folderId },
        body: { name },
      }),
      // invalidatesTags: [{ type: "FolderFileData", id: (arg) => arg.folderId }],
    }),
    deleteFolder: builder.mutation({
      query: ({ folderId }) => ({
        url: `/folder/delete-folder`,
        method: "DELETE",
        body: { folderId },
      }),
      invalidatesTags: [{ type: "FolderFileData", id: (arg) => arg.folderId }],
    }),
    moveFolder: builder.mutation({
      query: ({ folderId, newParentFolderId }) => ({
        url: `/folder/move-folder`,
        method: "POST",
        body: { folderId, newParentFolderId },
      }),
      invalidatesTags: [
        { type: "FolderFileData", id: (arg) => arg.folderId },
        { type: "FolderFileData", id: (arg) => arg.newParentFolderId },
      ],
    }),
    patchFavorite: builder.mutation({
      query: ({ workbookId, type }) => ({
        url: "/users/favouritesworkbook",
        method: "PATCH",
        body: { workbookId, type },
      }),
      invalidatesTags: [{ type: "FolderFileData", id: "root" }],
    }),
    deleteFavorite: builder.mutation({
      query: ({ workbookId, type }) => ({
        url: "/users/deletefavouritesWorkbook",
        method: "DELETE",
        body: { workbookId, type },
      }),
      invalidatesTags: [{ type: "FolderFileData", id: (arg) => arg.folderId }],
    }),
    deleteWorkbook: builder.mutation({
      query: ({ workbookId }) => {
        // console.log(workbookId); //{ workbookId: '66c586b22f9f12047c1b8db0' }
        return {
          url: `workbookapi/DeleteWorkbook`,
          method: "DELETE",
          params: { workbookId },
        };
      },
      invalidatesTags: [{ type: "FolderFileData", id: "root" }], // Adjust this based on your folder structure
    }),
    toggleFavorite: builder.mutation({
      query: (request) => ({
        url: `/users/toggleFavourites`,
        method: "PATCH",
        body: request,
      }),
      invalidatesTags: (result, error, { folderId }) =>
        folderId
          ? [{ type: "FolderFileData", id: folderId }]
          : [{ type: "FolderFileData", id: "root" }],
    }),
    renameWorkbook: builder.mutation({
      query: ({ workbookId, newName }) => ({
        url: `workbookapi/renameWorkbook`,
        method: "PATCH",
        body: { workbookId, newName },
      }),
      invalidatesTags: [{ type: "FolderFileData", id: "root" }], // Adjust this based on your folder structure
    }),
    moveWorkbook: builder.mutation({
      query: ({ workbookId, newFolderId }) => ({
        url: `workbookapi/moveWorkbook`,
        method: "POST",
        body: { workbookId, newFolderId },
      }),
      invalidatesTags: [
        { type: "FolderFileData", id: "root" },
        { type: "FolderFileData", id: (arg) => arg.newFolderId },
      ],
    }),
    duplicateWorkbook: builder.mutation({
      query: (workbookId) => {
        // console.log(workbookId);
        return {
          url: `workbookapi/duplicatedraft`,
          method: "GET",
          params: { workbookId },
        };
      },
    }),
    serachFolderAndWorkBooks: builder.query({
      query: ({ query }) => {
        return {
          url: "/search/workbookFolder",
          params: { query },
        };
      },
    }),
  }),
});

export const {
  useFolderContentMutation,
  useCreateFolderMutation,
  useEditFolderNameMutation,
  useDeleteFolderMutation,
  useMoveFolderMutation,
  usePatchFavoriteMutation,
  useDeleteFavoriteMutation,
  useDeleteWorkbookMutation,
  useRenameWorkbookMutation,
  useMoveWorkbookMutation,
  useToggleFavoriteMutation,
  useDuplicateWorkbookMutation,
  useLazySerachFolderAndWorkBooksQuery,
} = libraryApiSlice;

export const selectLibraryResult =
  libraryApiSlice.endpoints.getLibraryData.select();
